import React from 'react';
// import {
//   useLazyCheckEmailQuery,
//   useLazyCheckUsernameQuery,
// } from '@/store/services/AuthApi.service';

export default function EditProfile() {
  // const { t } = useTranslation();
  // // const [checkUsername] = useLazyCheckUsernameQuery({});
  // // const [checkEmail] = useLazyCheckEmailQuery({});
  // const [changeUsername] = usePostApiV1AccountUpdateprofileMutation();
  //
  // const { profile, reloadProfile } = useProfile();
  // const { showModal } = useModal();
  //
  // const [username, setUsername] = useState<string>(profile.username || '');
  // const [usernameError, setUsernameError] = useState<string | null>(null);
  //
  // const [email, setEmail] = useState<string>();
  // const [emailError, setEmailERror] = useState<string | null>(null);
  //
  // const onUsernameFieldChanged = (target: EventTarget & HTMLInputElement) =>
  //   setUsername(target.value);
  // const changeUsernameHandler = useCallback(async () => {
  //   if (!username || username.length < 3) return;
  //
  //   // const isAvailable = await checkUsername({ username }).unwrap();
  //   // if (!isAvailable) {
  //   //   setUsernameError('Username: "' + username + '" is not available');
  //   //   return;
  //   // }
  //
  //   changeUsername({ username }).finally(() => reloadProfile(null));
  // }, [username]);
  // // }, [checkUsername, username]);
  //
  // const onEmailFieldChanged = (target: EventTarget & HTMLInputElement) => setEmail(target.value);
  // const changeEmailHandler = useCallback(async () => {
  //   if (!email || email.length < 3) return;
  //
  //   // const emailCheckResult = await checkEmail({ email }).unwrap();
  //   // if (!emailCheckResult) {
  //   //   setUsernameError('Email: "' + email + '" is not available');
  //   //   return;
  //   // }
  // }, [email]);
  // // }, [checkEmail, email]);
  //
  // if (!profile) return null;

  return (
    <div className='flex flex-col gap-y-10 w-full pl-8'>
      {/*<h3 className='text-xl leading-7 font-bold text-center md:text-left'>{t('Edit Profile')}</h3>*/}
      {/*<div className='flex flex-col w-full gap-y-8'>*/}
      {/*  <div className='flex flex-col w-full gap-y-4'>*/}
      {/*    <h5 className='text-sm leading-5 font-semibold'>{t('Your Avatar')}</h5>*/}
      {/*    <div className='flex items-center gap-x-4'>*/}
      {/*      <div className='flex basis-1/3'>*/}
      {/*        <div className='w-16 h-16'>*/}
      {/*          <Avatar*/}
      {/*            name={String(profile.username)}*/}
      {/*            src={profile?.media?.path}*/}
      {/*            className='w-16 h-16'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*      <div className='flex gap-x-2 grow'>*/}
      {/*        <button*/}
      {/*          type='button'*/}
      {/*          className='px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-lg sm:w-36'*/}
      {/*          onClick={() => showModal('upload-avatar')}*/}
      {/*        >*/}
      {/*          {t('Change Picture')}*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='flex flex-col w-full gap-y-4'>*/}
      {/*    <h5 className='text-sm leading-5 font-semibold'>{t('Username')}</h5>*/}
      {/*    <div className='flex flex-col sm:flex-row items-start gap-4'>*/}
      {/*      <div className='flex flex-col gap-y-1 basis-1/3'>*/}
      {/*        <input*/}
      {/*          type='text'*/}
      {/*          placeholder={t('Username')}*/}
      {/*          className='px-3 py-1.5 text-sm w-full border-gray-300 rounded-lg '*/}
      {/*          defaultValue={profile.username}*/}
      {/*          onBlur={({ target }) => onUsernameFieldChanged(target)}*/}
      {/*        />*/}
      {/*        {usernameError && <span className='text-red-400 text-sm'>{usernameError}</span>}*/}
      {/*      </div>*/}
      {/*      <div className='flex gap-x-2 grow'>*/}
      {/*        <button*/}
      {/*          type='button'*/}
      {/*          className='px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-lg sm:w-36'*/}
      {/*          onClick={changeUsernameHandler}*/}
      {/*        >*/}
      {/*          {t('Change Username')}*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='not-ready flex flex-col w-full gap-y-4'>*/}
      {/*    <h5 className='text-sm leading-5 font-semibold'>{t('Email Address')}</h5>*/}
      {/*    <div className='flex flex-col sm:flex-row items-start gap-4'>*/}
      {/*      <div className='flex flex-col gap-y-1 basis-1/3'>*/}
      {/*        <input*/}
      {/*          type='text'*/}
      {/*          placeholder='your@email.com'*/}
      {/*          className='px-3 py-1.5 text-sm w-full border-gray-300 rounded-lg '*/}
      {/*          defaultValue={profile.email}*/}
      {/*          onBlur={({ target }) => onEmailFieldChanged(target)}*/}
      {/*        />*/}
      {/*        {emailError && <span className='text-red-400 text-sm'>{emailError}</span>}*/}
      {/*      </div>*/}
      {/*      <div className='flex gap-x-2 grow'>*/}
      {/*        <button*/}
      {/*          type='button'*/}
      {/*          className='px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-lg sm:w-36'*/}
      {/*          onClick={changeEmailHandler}*/}
      {/*        >*/}
      {/*          {t('Change Email')}*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='flex flex-col w-full gap-y-4'>*/}
      {/*    <h5 className='text-sm leading-5 font-semibold'>{t('Reset Password')}</h5>*/}
      {/*    <div className='flex flex-col sm:flex-row items-start gap-4'>*/}
      {/*      <div className='flex basis-1/3'>*/}
      {/*        <p className='text-sm leading-5 font-normal text-gray-400'>*/}
      {/*          {t('Set a unique password to protect your personal account.')}*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*      <div className='flex gap-x-2 grow'>*/}
      {/*        <button*/}
      {/*          type='button'*/}
      {/*          className='px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-lg sm:w-36'*/}
      {/*          onClick={() => showModal('reset-password')}*/}
      {/*        >*/}
      {/*          {t('Reset Password')}*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<Modal id='reset-password'>*/}
      {/*  <ResetPassword />*/}
      {/*</Modal>*/}
      {/*<Modal id='upload-avatar'>*/}
      {/*  <UploadAvatar />*/}
      {/*</Modal>*/}
    </div>
  );
}
